<template>
    <div>
        Das ist die Bestellugen site
    </div>

</template>

<script>
    export default {
        name: "Orders"
    }
</script>

<style scoped>

</style>